import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormValidationComponent } from './form.component';
import { FieldsModule } from '../../fields/fields.module';

@NgModule({
  declarations: [
    FormValidationComponent
  ],
  imports: [
    CommonModule,
    FieldsModule
  ], exports:[
    FormValidationComponent
  ]
})
export class FormValidationModule { }
